import { useState, useCallback } from 'react'
import { getPrescriptions } from '../api/prescriptions'
import { normalizePrescriptionsList } from '../utils/normalizer/prescriptionsNormalizer'

const inFlightPrescriptionsRequests = {}

export const usePrescriptionsData = () => {
	const [data, setData] = useState([])
	const [totalPages, setTotalPages] = useState(1)
	const [currentPage, setCurrentPage] = useState(1)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)

	const fetchData = useCallback(async (params = {}) => {
		setLoading(true)
		setError(null)
		try {
			const requestKey = JSON.stringify(params)

			if (!inFlightPrescriptionsRequests[requestKey]) {
				inFlightPrescriptionsRequests[requestKey] = getPrescriptions(params).finally(() => {
					delete inFlightPrescriptionsRequests[requestKey]
				})
			}

			const res = await inFlightPrescriptionsRequests[requestKey]
			setData(normalizePrescriptionsList(res.data?.items))
			setTotalPages(res.data?.totalPaginas || 1)
			setCurrentPage(res.data?.pagina || 1)
		} catch (err) {
			setError(err)
			setData([])
		} finally {
			setLoading(false)
		}
	}, [])

	return {
		data,
		totalPages,
		currentPage,
		loading,
		error,
		fetchData
	}
}
